/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { ButtonBase, Typography } from '@mui/material';
import type { ToastContentProps } from 'react-toastify';
import '../toast.css';

interface Props {
  closeToast: ToastContentProps['closeToast'];
  count: number;
  onOpenCenter: () => void;
}

/** "+N more" pill under the toast stack when more notifications arrived than fit. */
export default function OtherNotificationsToast({
  closeToast,
  count,
  onOpenCenter,
}: Readonly<Props>) {
  return (
    <ButtonBase
      className="notification-toast-shell"
      onClick={() => {
        onOpenCenter();
        closeToast('open-notification-center');
      }}
      sx={{ justifyContent: 'flex-start', gap: 0.75, px: 1.75, py: 1, textAlign: 'left' }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 600 }}>+{count} more</Typography>
      <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>·</Typography>
      <Typography sx={{ flex: 1, fontSize: 12, fontWeight: 500, color: 'primary.main' }}>
        Open notification center
      </Typography>
      <ArrowForwardRoundedIcon sx={{ fontSize: 15, color: 'primary.main' }} />
    </ButtonBase>
  );
}
